import { DIRECTIONS_URL } from '@constants';
import { EnumLangs, ICreateDirectionBody, IEditDirectionBody, IParams } from '@types';
import { errorHandler, getStorageItem, isEmpty } from 'helpers';
import { HttpService } from 'services';

import { globalSlice } from '../global';
import { AppDispatch } from '../index';
import { directionsSlice } from './directionsSlice';

const getDirections = (params?: IParams | null) => {
    const { setIsError, setIsLoading } = globalSlice.actions;
    const { setDirections } = directionsSlice.actions;

    const lang = getStorageItem('lang') || EnumLangs.HY;
    const queryString =
        params && !isEmpty(params)
            ? '?' +
              Object.keys(params)
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  .map((key: 'sortType' | 'orderBy' | 'page' | 'limit') => {
                      if (key === 'sortType') return 'mode=' + params[key];
                      if (key === 'orderBy') return 'sort=' + params[key];
                      return key + '=' + params[key];
                  })
                  .join('&')
            : '?';

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            const url = `${DIRECTIONS_URL}${queryString}&translation=${lang}`;

            const { data } = await HttpService({
                url,
            });

            dispatch(setIsError(false));
            dispatch(setDirections(data));
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const createDirection = (body: ICreateDirectionBody, name: string) => {
    const { setSnackbar, setIsLoading } = globalSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            await HttpService({
                url: DIRECTIONS_URL,
                method: 'POST',
                body,
            });

            dispatch(
                setSnackbar({
                    open: true,
                    message: 'has.been.created',
                    variant: 'success',
                    fullName: name,
                }),
            );
            dispatch(getDirections());
            return true;
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const deleteDirection = (id: string, name: string) => {
    const { setSnackbar, setIsLoading } = globalSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            await HttpService({
                url: `${DIRECTIONS_URL}/${id}`,
                method: 'DELETE',
            });

            dispatch(
                setSnackbar({
                    open: true,
                    message: 'has.been.deleted',
                    variant: 'success',
                    fullName: name,
                }),
            );
            dispatch(getDirections());
            return true;
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const editDirection = (body: IEditDirectionBody, uuid: string, name: string) => {
    const { setSnackbar, setIsLoading } = globalSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            await HttpService({
                url: `${DIRECTIONS_URL}/${uuid}`,
                method: 'PUT',
                body,
            });

            dispatch(
                setSnackbar({
                    open: true,
                    message: 'has.been.edited',
                    variant: 'success',
                    fullName: name,
                }),
            );
            dispatch(getDirections());
            return true;
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

const getDirectionById = (id: string) => {
    const { setIsError, setIsLoading } = globalSlice.actions;
    const { setDirection } = directionsSlice.actions;

    return async (dispatch: AppDispatch) => {
        dispatch(setIsLoading(true));

        try {
            const url = `${DIRECTIONS_URL}/${id}`;

            const { data } = await HttpService({
                url,
            });

            dispatch(setIsError(false));
            dispatch(setDirection(data));
        } catch (error: any) {
            errorHandler(error, dispatch);
        }

        dispatch(setIsLoading(false));
    };
};

export const directionsOp = {
    createDirection,
    getDirections,
    deleteDirection,
    editDirection,
    getDirectionById,
};
